<template>
  <div class="pagePhoneFooter">
    <p class="page_footer_phone_1">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
        >琼ICP备2024049139号-1</a
      >
    </p>
    <p class="page_footer_phone_2">世德物流集团有限公司 版权所有</p>
    <div class="page_footer_phone_3">
      <!-- <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011602001245"
        class="page_footer_des"
        ><img src="@img/footer_icon.png" /><span
          >津公网安备 12011602001245号</span
        ></a
      > -->
    </div>
  </div>
</template>
<script>
export default {
  name: "pageFooter",
  props: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "@css/variate.scss";
.pagePhoneFooter {
  height: 102px;
  background: #15151e;
  font-size: 12px;
  text-align: center;
  padding: 24px 0 20px 0;
  box-sizing: border-box;
  margin-top: 23px;
  a {
    color: #9099a0 !important;
  }
  .page_footer_phone_1 {
    color: #394854;
    line-height: 19px;

    /* margin: 24px 0 20px 0; */
  }
  .page_footer_phone_2 {
    color: #9099a0;
    line-height: 19px;
  }
  .page_footer_phone_3 {
    .page_footer_des {
      img,
      span {
        display: block;
      }
      img {
        margin-right: 5px;
        width: 16px;
        height: 16px;
      }
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/publicComponents/pagePhoneFooter.vue